import store from 'store'

const KEY_TOKEN = 'token'
const KEY_CODES = 'codes'
const KEY_SERVICE_TYPES = 'service_types'
const KEY_REPORT_SEARCH_PARAMS = 'report_search_params'
const KEY_STAFF_SHIFT_INPUTS = 'staff_shift_inputs'
const KEY_AUTO_RELOAD = 'auto_reload'

class Repository {
  clearToken () {
    store.remove(KEY_TOKEN)
  }

  //
  // SessionData
  //
  setToken (value) {
    if (value) value.saveDate = new Date().getTime()
    store.set(KEY_TOKEN, value)
  }

  getToken () {
    let value = store.get(KEY_TOKEN)
    if (value && value.saveDate) {
      const nowTime = new Date().getTime()
      const saveTime = value.saveDate
      const expireTime = saveTime + (value.expires_in * 1000 - 5000)
      if (expireTime < nowTime) {
        this.clearToken()
        value = null
      }
    }
    return value
  }

  //
  // ReportSearchParams
  //
  setReportSearchParams (value) {
    store.set(KEY_REPORT_SEARCH_PARAMS, JSON.stringify(value))
  }

  getReportSearchParams () {
    let val = store.get(KEY_REPORT_SEARCH_PARAMS)
    if (val) {
      val = JSON.parse(val)
    }
    return val
  }

  //
  // StaffShiftInputs
  //
  setStaffShiftInputs (value) {
    store.set(KEY_STAFF_SHIFT_INPUTS, JSON.stringify(value))
  }

  getStaffShiftInputs () {
    let val = store.get(KEY_STAFF_SHIFT_INPUTS)
    if (val) {
      val = JSON.parse(val)
    }
    return val
  }

  //
  // ServiceTypes
  //
  setServiceTypes (value) {
    store.set(KEY_SERVICE_TYPES, value)
  }

  getServiceTypes () {
    let value = store.get(KEY_SERVICE_TYPES)
    if (!value) {
      return []
    }
    return value
  }

  //
  // Codes
  //
  setCodes (value) {
    store.set(KEY_CODES, value)
  }

  getCodes () {
    let value = store.get(KEY_CODES)
    if (!value) {
      return []
    }
    return value
  }

  //
  // AutoReload
  //
  setAutoReload (value) {
    store.set(KEY_AUTO_RELOAD, value)
  }

  getAutoReload () {
    let value = store.get(KEY_AUTO_RELOAD)
    if (!value) {
      return null
    }
    return value
  }
}

export default new Repository()
